module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/gallery/tmb_gallery7-e656a016e6891946faab2d3f6443aa5d.jpg";